import { isCypress } from './standaloneUtils'

const isLocalHost = () => {
  return location.hostname === 'localhost'
    || location.hostname === '127.0.0.1'
    || location.hostname === '[::1]'
}

const isFirefox = () => navigator.userAgent.includes('Firefox/')

const clearWorkboxCaches = async () => {
  if (!('caches' in window)) return

  const keys = await caches.keys()
  await Promise.all(keys
    .filter(key => key.includes('workbox-precache'))
    .map(key => caches.delete(key)))
}

const unregisterServiceWorkers = async (clearCaches = false) => {
  const registrations = await navigator.serviceWorker.getRegistrations()
  for (const registration of registrations) {
    await registration.unregister() // eslint-disable-line no-await-in-loop
  }
  if (clearCaches) {
    await clearWorkboxCaches()
  }
  return registrations.length
}

const waitForWindowLoad = async () => {
  if (document.readyState === 'complete') return
  await new Promise<void>(resolve => {
    window.addEventListener('load', () => resolve(), { once: true })
  })
}

const waitForIdle = async () => {
  await new Promise<void>(resolve => {
    const requestIdle = (window as any).requestIdleCallback as undefined | ((cb: () => void, options?: { timeout: number }) => number)
    if (requestIdle) {
      requestIdle(resolve, { timeout: 15_000 })
    } else {
      setTimeout(resolve, 15_000)
    }
  })
}

// might not resolve at all
export const registerServiceWorker = async () => {
  if (!('serviceWorker' in navigator) || process.env.SINGLE_FILE_BUILD) return
  if (process.env.DISABLE_SERVICE_WORKER) return

  // In local replay work and Firefox, SW precache competes with startup data
  // loading and can keep stale heavy caches across rebuilds. Browser HTTP cache
  // is enough here, so remove any previous workbox worker/cache.
  if (isLocalHost() || isFirefox()) {
    await unregisterServiceWorkers(true)
    return
  }

  if (!isCypress() && process.env.NODE_ENV !== 'development') {
    await waitForWindowLoad()
    await waitForIdle()
    await navigator.serviceWorker.register('./service-worker.js').then(registration => {
      console.log('SW registered:', registration)
    }).catch(registrationError => {
      console.log('SW registration failed:', registrationError)
    })
  } else {
    // force unregister service worker in development mode
    const unregisteredCount = await unregisterServiceWorkers()
    if (unregisteredCount) {
      location.reload()
    }
  }
}
